const initialCharacters = [
  '(I Noldor) Finwe Noldoran',
  '(I Noldor) Miriel Perinde Serinde',
  '(I Noldor) Mahtan Aulendir (Urundil, Rusco)',
  '(I Vanyar) Indis The Fair',
  '(II Noldor) Feanor Curufinwe Feanaro',
  '(II Noldor) Nerdanel the Wise',
  '(III Noldor) Maethros the Tall (Dispossessed, Maitimo)',
  '(III Noldor) Maglor Macalaure Canafinwe',
  '(III Noldor) Celegorm the Fair (Turcafinwe, Tyelkormo)',
  '(III Noldor) Caranthir the Dark (Carnistir, Morifinwe)',
  '(III Noldor) Curufin the Crafty (Curufinwe, Atarinke)',
  '(IV Noldor) Celebrimbor Telperinquer',
  '(III Noldor) Amrod (Ambarussa, Ambarto, Umbarto, Telufinwe)',
  '(III Noldor) Amras (Ambarussa, Diriel, Pityafinwe)',
  '(II Noldor) Fingolfin Nolofinwe Arakano',
  '(II Noldor) Anarie Holiest',
  '(III Noldor) Fingon the Valiant (Findekano)',
  '(III Noldor) Turgon the Wise (Turukano)',
  '(III Vanyar) Elenwe (wife of Turgon)',
  '(IV Noldor) Idril Celebrindal (Itaril, Itarille, Itarilde)',
  "(V Noldor) Earendil Blessed (The Mariner, Half-elf, Bright, Blessed, Ardamire, Mir n'Ardhon, Azrubel)",
  '(IV Sindar) Elwing The White',
  'Elrond Peredhel',
  'Elros Tar-Minyatur (Elerosse, Indilzar)',
  '(III Noldor) Aredhel Ar-Feiniel, Irisse, Isfin',
  '(III Avari) Eol Dark Elf',
  '(IV Avari) Maeglin Lomion',
  '(III Noldor) Argon Arakano',
  '(II Noldor) Finarfin Arafinwe',
  '(II Noldor) Findis (daughter Finwe and Indis)',
  '(II Noldor) Irime (daughter Finwe and Indis)',
  '(II Falmari) Earwen Swan-Maiden of Alqualonde',
  '(III Noldor) Finrod Felagund (Finarfin (in earlier texts), Ingoldo, Findarato/Artafinde, Nom or Nomin)',
  '(III Noldor) Angrod Angaráto',
  '(III Noldor) Eldalote (Edhellos)',
  '(IV Noldor) Orodreth (Artaher, Arothir, Artaresto)',
  '(V Noldor) Findulias (Faelivrin)',
  '(V Noldor) Gil-galad (Artanaro/Rodnor, Ereinion, Finellach)',
  '(III Noldor) Aegnor (Egnor, Aikanár, Aikanáro)',
  '(III Noldor) Galadriel (Alatariel, Artanis, Nerwen)',
  '(III Sindar) Celeborn (Teleporno)',
  '(III Noldor) Celebrian (daughter of Celeborn and Galadriel)',
  '(I Sindar) Elu Tingol (Elwë, Tinwelint, Singollo, Sindicollo ("Greymantle"))',
  'Melian (Melyanna, Toril, Gwendeling)',
  '(II Sindar) Luthien Tinuviel',
  '(I Beor) Beor (Balan, Beor the Old)',
  '(II Beor) Baran',
  '(III Beor) Boron',
  '(IV Beor) Boromir',
  "(V Beor) Andreth Saelind, 'Wise-woman' of the Edain",
  '(V Beor) Bregor',
  '(VI Beor) Bregolas',
  '(VII Beor) Baragund',
  '(VIII Beor) Morwen Eledhwen',
  '(VII Beor) Belegund',
  '(VIII Beor) Rian',
  '(VI Beor) Barahir',
  '(VII Beor) Beren Erchamion (Camlost)',
  '(II Beor) Belen',
  '(III Beor) Beldir',
  '(IV Beor) Belemir',
  "(V Beor) Beren (Belemir's son)",
  '(VI Beor) Emeldir the Manhearted (wife of Barahir)',
  '(I Hador) Hador Lorindol',
  '(I Hador) Gildis',
  '(II Hador) Gundor',
  '(II Hador) Galdor the Tall',
  '(V Haleth) Hareth',
  '(II Hador) Gloredhel',
  '(V Haleth) Haldir',
  '(III Hador) Hurin Thalion, Umarth',
  '(IV Hador) Turin (Adanedhel, Agarwaen, Dagnir Glaurunga, Gorthol, Mormegil, Neithan, Thurin, Turambar, Turindo, Wildman of the Woods)',
  '(IV Hador) Urwen Lalaith',
  '(IV Hador) Nienor Niniel',
  '(III Hador) Huor',
  '(IV Hador) Tuor Eladar',
  '(I Haleth) Haldad',
  '(II Haleth) Haleth',
  '(II Haleth) Haldar',
  '(III Haleth) Haldan',
  '(IV Haleth) Halmir',
  '(VI Haleth) Handir',
  '(VII Haleth) Brandir',
  'Dior Eluchil',
  'Nimloth (Lady Lindis)',
  'Elured, the twin son of Dior Eluchil',
  'Elurin, the twin son of Dior Eluchil',
  'Elendil (The Tall, the Fair, Voronda, Nimruzîr)',
  'Isildur',
  'Anarion',
  'Aragorn Elessar',
  'Arven Undomiel (Evenstar)',
  'Frodo Baggins',
  'Drogo Baggins',
  'Primula Baggins',
  'Bilbo Baggins',
  'Sem Gamgee',
  'Meriadoc (Merry) Brandybuck',
  'Peregrin (Pippin) Took',
  'Gandalf Olorin, Mithrandir, Incfanus, Tharkun, Greyhame, Old Greybeard, The Grey Pilgrim, Stormcrow, White Rider, Lathspell, the Wandering Wizard',
  'Gimli Elf-friend, Lockbearer',
];

export { initialCharacters };
